// The only container exposed externally is the interfaceContainer
import interfaceContainer from './lib/interfaceContainer';
export default interfaceContainer;
